
export const types = {
    SET_COLLAPSED: 'setCollapsed',
    SET_SPIN: 'showSpin'
}

const initialState = {
    collapsed: false,
    spin: false
}
export default function reducer(state = initialState, action: any = {}) {
    switch (action.type) {
        case types.SET_COLLAPSED:
            return {
                ...state,
                collapsed: action.collapsed
            }
        case types.SET_SPIN:
            return {
                ...state,
                spin: action.spin
            }
        default: return state
    }
}

export const layoutActions = {
    setCollapsed: function(data: object) {
        return { type: types.SET_COLLAPSED, ...data }
    },
    setSpin: function(data: object) {
        return { type: types.SET_SPIN, ...data }
    }
}